var React = require('react');

function ShopArrow (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.140625","y":"13.8052","width":"19.8727","height":"2.03644","transform":"rotate(-44.002 0.140625 13.8052)","fill":"black","key":0}),React.createElement("path",{"d":"M1.60937 12.3835L15.0866 26.3137L13.623 27.7297L0.145793 13.7995L1.60937 12.3835Z","fill":"black","key":1})]);
}

ShopArrow.defaultProps = {"width":"16","height":"28","viewBox":"0 0 16 28","fill":"none"};

module.exports = ShopArrow;

ShopArrow.default = ShopArrow;
